import {mix, Eventable} from '../mixin';

const {window, document} = globalThis;

let hiddenString;
let visibilityChangeString;
let lastChangeSubtype = '';
let checkFocus = false;

/**
 * @namespace visibilityChecker
 * @mixes Eventable
 */
const methods = /** @lends visibilityChecker */
{
    /** Ist das Fenster sichtbar?
     * @return {boolean}
     */
    isVisible()
    {
        if (checkFocus)
        {
            return !(document[hiddenString] || !document.hasFocus());
        }
        return !document[hiddenString];
    },
    /** Grundsätzlich wird nur die Visibility API gecheckt. Setzt man den `focusCheck` auf `true`, wird auch registriert,
     * wenn das Fenster Fokus verliert oder bekommt. Nachteil: Das passiert auch, wenn man in die Adresseleiste klickt.
     * @param {boolean} active
     */
    setFocusCheck(active)
    {
        checkFocus = active;
    }
};

const checker = mix(methods, true).with(Eventable);

if (typeof document.hidden !== 'undefined')
{
    hiddenString = 'hidden';
    visibilityChangeString = 'visibilitychange';
}
else if (typeof document.mozHidden !== 'undefined')
{
    hiddenString = 'mozHidden';
    visibilityChangeString = 'mozvisibilitychange';
}
else if (typeof document.msHidden !== 'undefined')
{
    hiddenString = 'msHidden';
    visibilityChangeString = 'msvisibilitychange';
}
else if (typeof document.webkitHidden !== 'undefined')
{
    hiddenString = 'webkitHidden';
    visibilityChangeString = 'webkitvisibilitychange';
}

/**
 * Wird bei einem Wechsel der Sichtbarkeit gefeuert.
 * @event visibilityChecker#visibilityChange
 * @property {boolean} visible
 * @property {string} subtype - `api` oder `focus`
 */

document.addEventListener(visibilityChangeString, () =>
{
    checker.fire('visibilityChange', {visible: !document[hiddenString], subtype: 'api'});
    lastChangeSubtype = 'api';
});

window.addEventListener('blur', () =>
{
    if (checkFocus && !document[hiddenString])
    {
        lastChangeSubtype = 'focus';
        checker.fire('visibilityChange', {visible: false, subtype: 'focus'});
    }
});

window.addEventListener('focus', () =>
{
    if (checkFocus && lastChangeSubtype === 'focus')
    {
        checker.fire('visibilityChange', {visible: true, subtype: 'focus'});
    }
});

export default checker;
